module.exports = __webpack_public_path__ + "assets/media/day37.2a3a2335.mp3";